import { render, staticRenderFns } from "./login-1.vue?vue&type=template&id=7935a2b4"
import script from "./login-1.vue?vue&type=script&lang=js"
export * from "./login-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports